var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-footer',[_c('div',{staticStyle:{"height":"30px"}}),_vm._v(" "),_c('div',{staticClass:"footer"},[_vm._v("ICP："),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/"}},[_vm._v(_vm._s(_vm.procedureICP))]),_vm._v("  Copyright ："+_vm._s(_vm.companyName)+"  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13ce2360","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/template/foot.vue
// module id = null
// module chunks = 